import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ActivityStateService } from '@services/activity/state/activity-state.service';

@Component({
  selector: 'ts-admin-override-banner',
  templateUrl: './admin-override-banner.component.html',
  imports: [FormsModule, NgbAlertModule, TranslationPipe]
})
export class AdminOverrideBannerComponent {
  @Input() hide_admin_only: boolean = false;
  @Input() hide_review_toggles?: boolean = false;
  @Input() admin_override: boolean | undefined = undefined;
  @Input() skip_policy_agreement: boolean | undefined = undefined;
  @Input() skip_approval: boolean | undefined = undefined;
  @Input() suppress_user_email: boolean | undefined = undefined;
  @Input() select_all: boolean | undefined = undefined;
  @Input() disabled: boolean = false;
  @Input() prevent_default: boolean = false;
  @Output() emit_cart_change = new EventEmitter<boolean>(false);
  @Output() emit_admin_override = new EventEmitter<boolean>(false);
  @Output() emit_select_all_overrides = new EventEmitter<boolean>(false);
  @Output() emit_skip_approval = new EventEmitter<boolean>(false);
  @Output() emit_skip_policy_agreement = new EventEmitter<boolean>(false);
  @Output() emit_suppress_user_email = new EventEmitter<boolean>(false);

  constructor(private activity_state_svc: ActivityStateService) {}

  get admin_override_supported(): boolean | undefined {
    return this.activity_state_svc.getAdminOverrideSupported();
  }

  toggleAdminOverride(e: any): void {
    if (!e.target.checked && this.prevent_default) {
      e.preventDefault();
      this.emit_cart_change.emit(e.target.checked);
      return;
    }

    this.emit_admin_override.emit(e.target.checked);
  }

  toggleBypassAllProcesses(e: any): void {
    this.emit_select_all_overrides.emit(e.target.checked);
    const isChecked = e.target.checked;

    this.skip_approval = isChecked;
    this.skip_policy_agreement = isChecked;
    this.suppress_user_email = isChecked;

    this.emit_skip_approval.emit(isChecked);
    this.emit_skip_policy_agreement.emit(isChecked);
    this.emit_suppress_user_email.emit(isChecked);

    this.disabled = isChecked;
  }

  toggleSkipApproval(e: any): void {
    if (!e.target.checked && this.prevent_default) {
      e.preventDefault();
      return;
    }

    this.emit_skip_approval.emit(e.target.checked);
  }

  toggleSkipPolicyAgreement(e: any): void {
    if (!e.target.checked && this.prevent_default) {
      e.preventDefault();
      return;
    }

    this.emit_skip_policy_agreement.emit(e.target.checked);
  }

  toggleSupressUserEmail(e: any): void {
    if (!e.target.checked && this.prevent_default) {
      e.preventDefault();
      return;
    }

    this.emit_suppress_user_email.emit(e.target.checked);
  }
}
